import { IconButton } from "./Button.tsx";
import { DiscloseIcon } from "./icons.tsx";

/**
 * Opens or closes what's under it (a branch, an email of a thread): a chevron, pointing down when open. Without
 * `onToggle`, just the mark (in something clickable already).
 */
export function Chevron(p: { open: boolean; label: string; onToggle?: () => void; class?: string }) {
  const icon = <DiscloseIcon size={14} class={`transition-transform ${p.open ? "rotate-90" : ""}`} />;
  return p.onToggle ? (
    <IconButton size="2xs" class={p.class ?? ""} aria-expanded={p.open} label={p.label} onClick={p.onToggle}>
      {icon}
    </IconButton>
  ) : (
    <span class="inline-flex size-5 shrink-0 items-center justify-center text-zinc-500">{icon}</span>
  );
}
